import type { Dispatch, SetStateAction } from 'react';
import type { FormApi } from '../../useFormApi';

import { useEffect } from 'react';

import { useFormApi } from '../../useFormApi';

export type SetFormApiFn = Dispatch<SetStateAction<FormApi | undefined>>;

interface FormStateHandlerProps {
  /**
   * Callback for updating form state
   */
  setFormState?: SetFormApiFn;
}

const FormStateHandler = ({ setFormState }: FormStateHandlerProps) => {
  const formProps = useFormApi();

  useEffect(() => {
    setFormState?.(formProps);
  }, [formProps, setFormState]);

  return null;
};

export default FormStateHandler;
